import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-termsnconditions',
  templateUrl: './termsnconditions.component.html',
  styleUrls: ['./termsnconditions.component.css']
})
export class TermsnconditionsComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
